import { inject, observer } from 'mobx-react';
import React from 'react';
import clsx from 'classnames';

import { INPUT_TYPE, TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { handleRequest } from '@/utils';
import { addDialogue } from '@/utils/sessionUtils';
import { handleClickHistoryButton } from '@/utils/tools';
import Msg from '@/components/Msg';
import { tracker } from '@/utils/tracking';
import { getChildInject, isNum } from '@/utils/instantLoaded/tools';
import { IntentSource } from '@/types/intent';

import './style.scss';

const PREFIX = 'qaButton-container';

@tracker
@inject(getChildInject('initStore'))
@observer
export default class QAButton extends React.PureComponent {
  static defaultProps = {
    // props
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    msgContent: '',
    buttons: [],
    disabledBtn: false,
    // stores
    initStore: {},
  };

  constructor(props) {
    super(props);

    const {
      buttons,
      dialogueId,
      initStore,
      nodePointId,
      isHistory,
      historyDialogueId,
      historySessionId,
      kbBotId,
      kbBotName,
    } = this.props;

    this.articleGroup = [];
    this.buttonDetails = [];

    buttons.map(article => {
      this.articleGroup.push(article.article_number ?? article.intent_id);
      this.buttonDetails.push({
        button_text: article.title,
        button_id: article.button_id,
        button_type: article.button_type,
        intent_source: article.intent_source,
        kb_intent_id: article.intent_source === IntentSource.KnowledgeBase ? article.intent_id : undefined,
        bot_id: kbBotId,
        bot_name: kbBotName,
      });
    });

    this.trackingname = TRACKING_TYPE.ARTICLEGROUP;
    this.trackingdata = {
      article_group: this.articleGroup,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_details: this.buttonDetails,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
  }

  handleButtonClick = (button) => () => {
    const {
      dialogueId,
      dialogueType,
      initStore,
      isHistory,
      clarification_stage,
      thread_id,
      thread_node_id,
      thread_id_v2,
      round_id,
      customCallback = {},
    } = this.props;
    const { sessionId } = initStore;

    // 点击埋点
    this.trackingHandler(button);

    if (isHistory) {
      handleClickHistoryButton();
      return;
    }

    const curPos = addDialogue({
      dialogueId,
      dialogueType,
      from: 'user',
      type: 'Msg',
      data: { content: button.title },
    });

    if (isNum(curPos)) {
      handleRequest('postMessage', {
        session_id: sessionId,
        dialogue_id: dialogueId,
        input_type: INPUT_TYPE.BUTTON,
        message_text: button.title,
        thread_id,
        thread_node_id,
        thread_id_v2,
        round_id,
        message_extra: {
          article_number: button.article_number,
          intent_id: button.intent_id != null ? String(button.intent_id) : button.intent_id,
          clarification_stage,
        },
        ...customCallback,
      });
    }
  };

  // 埋点用 - 点击事件
  trackingHandler = (data) => {
    const {
      dialogueId,
      initStore,
      tracker,
      nodePointId,
      isHistory,
      historyDialogueId,
      historySessionId,
      kbBotId,
      kbBotName,
    } = this.props;

    tracker.click({
      trackingname: this.trackingname,
      data: {
        article_group: this.articleGroup,
        article_id: data.article_number ?? data.intent_id,
        chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        node_point_id: nodePointId,
        button_text: data.title,
        button_id: data.button_id,
        button_type: data.button_type,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
        intent_source: data.intent_source,
        kb_intent_id: data.intent_source === IntentSource.KnowledgeBase ? data.intent_id : undefined,
        bot_id: kbBotId,
        bot_name: kbBotName,
      },
    });
  };

  generateButton = (button, index) => {
    const { disabledBtn } = this.props;
    const props = {
      className: clsx('button-container', { disabled: disabledBtn }),
      key: `button-${index}`,
      onClick: this.handleButtonClick(button),
    };
    return <div {...props} >
      {button.title}
    </div>;
  };

  render() {
    const {
      msgContent,
      buttons,
      isDisabled,
      passedRef,
    } = this.props;
    const trackingdata = JSON.stringify(this.trackingdata);

    return <div
      className={PREFIX}
      ref={passedRef}
      data-trackingname={this.trackingname}
      data-trackingdata={trackingdata}
    >
      <Msg content={msgContent} />
      {
        isDisabled
          ? null
          : <div className="buttons">
            {
              buttons.map((button, index) => {
                return this.generateButton(button, index);
              })
            }
          </div>
      }
    </div>;
  }
}
